"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Checkbox = exports.RadioButton = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var RadioButton = function RadioButton(props) {
  var givenClassName = props.className,
      _props$convertValue = props.convertValue,
      convertValue = _props$convertValue === void 0 ? function (value) {
    return value;
  } : _props$convertValue,
      _props$onChange = props.onChange,
      onChange = _props$onChange === void 0 ? function () {} : _props$onChange,
      radioProps = (0, _objectWithoutProperties2["default"])(props, ["className", "convertValue", "onChange"]);
  var className = (0, _classnames["default"])("radio-button", givenClassName);
  var handleChange = (0, _react.useCallback)(function (event) {
    onChange({
      target: {
        name: event.target.name,
        value: convertValue(event.target.value)
      }
    });
  }, [onChange, convertValue]);
  return /*#__PURE__*/_react["default"].createElement("span", {
    className: className
  }, /*#__PURE__*/_react["default"].createElement("input", (0, _extends2["default"])({}, radioProps, {
    className: "radio-button__input",
    type: "radio",
    onChange: handleChange
  })), /*#__PURE__*/_react["default"].createElement("span", {
    className: "radio-button__styled-input"
  }));
};

exports.RadioButton = RadioButton;
RadioButton.propTypes = {
  className: _propTypes["default"].string,
  onChange: _propTypes["default"].func
};

var Checkbox = function Checkbox(props) {
  var error = props.error,
      checkboxProps = (0, _objectWithoutProperties2["default"])(props, ["error"]);
  var className = (0, _classnames["default"])("checkbox", props.className, {
    "checkbox--error": error
  });
  var styledInputClassName = (0, _classnames["default"])("checkbox__styled-input", {
    "checkbox__styled-input--error": error
  });
  var checked = "checked" in props ? props.checked : props.value;
  return /*#__PURE__*/_react["default"].createElement("span", {
    className: className
  }, /*#__PURE__*/_react["default"].createElement("input", (0, _extends2["default"])({}, checkboxProps, {
    className: "checkbox__input",
    type: "checkbox",
    checked: checked
  })), /*#__PURE__*/_react["default"].createElement("span", {
    className: styledInputClassName
  }));
};

exports.Checkbox = Checkbox;
Checkbox.propTypes = {
  className: _propTypes["default"].string,
  error: _propTypes["default"].any,
  value: _propTypes["default"].any,
  checked: _propTypes["default"].bool
};